import { render, staticRenderFns } from "./formulario-inscripcion.vue?vue&type=template&id=39257cc2"
import script from "./formulario-inscripcion.vue?vue&type=script&lang=js"
export * from "./formulario-inscripcion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports